import Link from 'next/link'
import { memo } from 'react'

import { Button } from '@/components/elements/buttons/button'

import { TechnologiesAvatarGroup } from '../../images/technologiesAvatarGroup'
import TiltCard from '../components/tiltCard'

const JobOfferCard = ({ id, name, subtitle, description, technologies }) => (
  <TiltCard className="job-offer-card">
    <Link href={`/job-offers/${id}`}>
      <div className="job-offer-card-container">
        <div className="job-offer-card-title-container">
          {name && <span className="job-offer-card-offer-name">{name}</span>}
          {subtitle && <span className="job-offer-card-offer-subtitle">{subtitle}</span>}
        </div>
        <div className="job-offer-card-offer-description">
          {description && <p>{description}</p>}
        </div>
      </div>
    </Link>
    <span className="job-offer-bottom">
      <Link href={`/contact?subject=${name}`}>
        <Button className="job-offer-card-offer-button" text="Apply Now" />
      </Link>
      <TechnologiesAvatarGroup technologies={technologies} />
    </span>
  </TiltCard>
)

export default memo(JobOfferCard)
